const shopDomains = [
  { language: "nl", domain: "nl.grandado.com" },
  { language: "fr", domain: "fra.grandado.com" },
  { language: "it", domain: "ita.grandado.com" },
  { language: "es", domain: "esp.grandado.com" },
  { language: "pt", domain: "prt.grandado.com" },
  { language: "de", domain: "deu.grandado.com" },
  { language: "en", domain: "aus.grandado.com" },
  { language: "pl", domain: "pol.grandado.com" },
  { language: "tr", domain: "tur.grandado.com" },
];

$(document).ready(() => {
  const linksWrapper = document.querySelector(".links-wrapper");
  const languageTooltip = document.querySelector(".to-another-shop");
  const closeButton = document.querySelector(".close-dialog");

  $(closeButton).on("click", closeBlock);

  const languageSupported = navigator.languages.includes(Shopify.locale);

  if (!languageSupported) {
    linksWrapper.innerHTML = createLinks();

    if (!localStorage.getItem("showed-redirect")) {
      setTimeout(() => {
        languageTooltip.classList.remove("hide-lang-tooltip");
        languageTooltip.classList.add("show-lang-tooltip");
      }, 5000);
    }
  }
});

function renderLink(domain) {
  return `<a class="shop-link" href="https://${domain}" title="${domain}">${domain}</a>`;
}

function createLinks() {
  const compatibleShopDomains = shopDomains.filter((shopLanguage) =>
    navigator.languages.includes(shopLanguage.language)
  );

  if (compatibleShopDomains.length === 0) {
    return `<div>${renderLink("en.grandado.com")}</div>`;
  }

  return `<div>${compatibleShopDomains
    .map(({ domain }) => renderLink(domain))
    .join("")}</div>`;
}

function closeBlock() {
  const languageTooltip = document.querySelector(".to-another-shop");
  languageTooltip.classList.remove("show-lang-tooltip");
  languageTooltip.classList.add("hide-lang-tooltip");
  localStorage.setItem("showed-redirect", "true");
}
